import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse = (value: any): Date | null => {
    if (typeof value === 'string') {
      let day, month, year;

      if (value.match(/^\d{1,2}\.\d{1,2}\.\d{4}$/)) {
        const [dayStr, monthStr, yearStr] = value.split('.');
        day = Number(dayStr);
        month = Number(monthStr);
        year = Number(yearStr);
      } else if (value.match(/^\d{8}$/)) {
        day = Number(value.substring(0, 2));
        month = Number(value.substring(2, 4));
        year = Number(value.substring(4, 8));
      } else {
        return null;
      }

      if (!isValidDate(day, month, year)) {
        return null;
      }

      return new Date(year, month - 1, day);
    }
    return null;
  };

  override format = (date: Date, displayFormat: any): string => {
    if (date) {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
    return super.format(date, displayFormat);
  };
}

export const isValidDate = (
  day: number,
  month: number,
  year: number
): boolean => {
  if (month < 1 || month > 12 || day < 1 || year.toString().length !== 4) {
    return false;
  }

  const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  const monthLengths = [
    31,
    isLeapYear ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  return day <= monthLengths[month - 1];
};
